import * as React from 'react';
import { ReportKind } from 'Data';
import { observer } from 'mobx-react';
import { IHeaderWithCommercialProps } from './IHeaderWithCommercialProps';

@observer
export class HeaderWithCommercials extends React.Component<IHeaderWithCommercialProps, undefined> {
  constructor(props: IHeaderWithCommercialProps) {
    super(props, undefined);
  }

  render() {
    const facilityLogo = this.props.facilities &&
      this.props.facilities.length > 0 &&
      this.props.facilities[0].logo !== '' && <img src={this.props.facilities[0].logo} alt="" />;

    const trackmanLogo = (
      <a href="http://trackmangolf.com/" target="_blank" rel="noopener noreferrer">
        <img src="Images/unleash-potential-logo-new.png" alt="Trackman logo" />
      </a>
    );

    const individualPlayers = this.props.individualPlayers && (
      <div className="players-name">
        {this.props.individualPlayers.map((currentPlayer, i) => {
          return (
            currentPlayer.name && [
              <span key={currentPlayer.id} className="player-name">
                {currentPlayer.name}
              </span>,
              this.props.individualPlayers.length > 0 &&
              i !== this.props.individualPlayers.length - 1 ? (
                <span>,&nbsp;</span>
              ) : null,
            ]
          );
        })}
      </div>
    );

    const date = this.props.reportDate && (
      <p className="date">{this.props.reportDate.toLocaleDateString()}</p>
    );
    const siteName = this.props.siteName !== '' &&
      this.props.reportKind === ReportKind.drShotAnalysis && (
        <p className="site-name">{this.props.siteName}</p>
      );

    const facilityLogoWarapper =
      this.props.facilities.length > 0 &&
      (this.props.facilities[0].link !== '' ? (
        <a
          className="box-wrapping-facility-logo"
          href={this.props.facilities[0].link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {facilityLogo}
        </a>
      ) : (
        <span className="box-wrapping-facility-logo">{facilityLogo}</span>
      ));

    const sponsoLogo = (logo: string) => logo && <img src={logo} alt="" />;

    const sponsors =
      this.props.sponsors &&
      this.props.sponsors.map(sponsor => {
        if (sponsor.kind === 'Main' && sponsor.link !== '') {
          return (
            <a
              className="box-wrapping-sponsor-top-logo"
              key={sponsor.id}
              href={sponsor.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              {sponsoLogo(sponsor.logo)}
            </a>
          );
        } else if (sponsor.link === '') {
          return (
            <span className="box-wrapping-sponsor-top-logo" key={sponsor.id}>
              {' '}
              {sponsoLogo(sponsor.logo)}{' '}
            </span>
          );
        }
        return <div></div>;
      });

    return (
      <div className="header-with-commercials">
        {this.props.isWeb && (
          <div className="row row-with-commercials">
            <div className="left-logo col-xs-2">{facilityLogoWarapper}</div>
            <div className="logo-and-player-info col-xs-8">
              {trackmanLogo}
              {siteName}
              {individualPlayers}

              {date}
            </div>
            <div className="right-logo col-xs-2">{sponsors}</div>
          </div>
        )}
        {this.props.isTps && (
          <div className="row row-with-commercials">
            <div className="logo-and-player-info col-xs-12">
              {trackmanLogo}
              {individualPlayers}
              {date}
            </div>
          </div>
        )}
        <div className="print-separation-line"></div>
      </div>
    );
  }
}
